import {
  fetchClient
} from "./chunk-K342ITN7.mjs";
import {
  generateRecaptchaToken
} from "./chunk-W4XMZLKW.mjs";
import {
  __async
} from "./chunk-DFMI36TU.mjs";

// src/core/wbk/nafath/send.ts
import { getLocaleOnly } from "@wbk/utils";
import { Exception } from "@wbk/logger";
var requestNafath = (_0) => __async(void 0, [_0], function* ({ id, locale }) {
  try {
    const lang = getLocaleOnly(locale);
    const captcha = yield generateRecaptchaToken("nafath");
    const data = yield fetchClient({
      url: "/nafath/send-request",
      options: {
        method: "POST",
        body: JSON.stringify({ id, lang, captcha })
      }
    });
    return data;
  } catch (error) {
    throw new Exception({
      error,
      name: "requestNafathException",
      context: { extra: { id } }
    });
  }
});

export {
  requestNafath
};
//# sourceMappingURL=chunk-AM6KDUML.mjs.map